/**
 * Componente para el botón de Radar de la navegación inferior
 * No muestra contador, solo el estado activo/inactivo
 * Adaptado de la versión móvil
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RadarIcon from '../../Icons/RadarIcon';

const RadarButton = ({ disableNavigation = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determinar si la ruta actual es la de radar
  const isActive = location.pathname === '/radar';
  
  /**
   * Maneja la navegación a la pantalla de radar
   */
  const handlePress = () => {
    if (!disableNavigation) {
      navigate('/radar');
    }
  };
  
  /**
   * Estilo del botón según estado activo
   */
  const buttonStyle = `
    relative flex flex-col items-center justify-center
    w-20 h-12 rounded-full transition-all duration-200
    ${isActive ? 'bg-neutral-700' : 'hover:bg-neutral-800'}
  `;
  
  return (
    <button
      className={buttonStyle}
      onClick={handlePress}
      aria-label="Ir a radar"
    >
      {/* Icono de radar */}
      <RadarIcon
        active={isActive}
        size={32}
        color="#A89CA6"
      />
    </button>
  );
};

export default RadarButton;
